import * as React from 'react';

import { Button, Alert } from 'reactstrap';

import { Form, Field } from 'react-final-form';

// networking
import AxiosHelper from 'services/AxiosHelper';
import * as axios from 'axios';
import { AxiosError } from 'axios';

// components
import Input from '../shared/Input';
import Spinner from 'components/shared/Spinner';
import { handleAxiosErrorWithValidation } from 'util/Misc';
import { NavLink } from 'react-router-dom';

import createDecorator from 'final-form-focus';
const focusOnErrors = createDecorator();

export interface ResetPasswordState {
	code: string | null;
	success: boolean;
}

/**
 * ResetPassword component
 *
 * @class ResetPassword
 * @extends {React.PureComponent<any>}
 */
class ResetPassword extends React.PureComponent<any, ResetPasswordState> {
	private cancelToken: any = null;

	constructor(props) {
		super(props);

		let code: string | null = null;

		if (props.location && props.location.search) {
			const searchParams = new URLSearchParams(props.location.search);
			if (searchParams.has('code')) {
				code = searchParams.get('code');
			}
		}

		this.state = {
			code,
			success: false,
		};
	}

	public componentWillUnmount() {
		if (this.cancelToken) {
			this.cancelToken();
		}
	}

	public submit = (formValues: any): Promise<void | Record<string, string>> => {
		if (this.cancelToken) {
			this.cancelToken();
		}

		const url = `/ajax/reset-password/`;

		formValues.code = this.state.code;

		return AxiosHelper.post(url, formValues, {
			cancelToken: new axios.default.CancelToken((token) => {
				this.cancelToken = token;
			}),
		})
			.then(() => {
				this.setState({ success: true });
			})
			.catch((error: AxiosError) => {
				return handleAxiosErrorWithValidation(error, null);
			})
			.then((promise: any) => {
				this.cancelToken = null;
				return promise;
			});
	};

	public render() {
		if (this.state.success) {
			return (
				<div className="login-form">
					<div>
						<h2 className="login-form-heading">Success</h2>
						<h2 className="login-form-heading">
							Your password has been successfully reset. Now you can login using your new password.
						</h2>

						<p className="login-form-heading">
							<NavLink to="/login" exact className="text-bold" activeClassName="active">
								Click here to go back to the login page.
							</NavLink>{' '}
						</p>
					</div>
				</div>
			);
		}

		return (
			<div className="login-form-wrapper">
				{!this.state.code ? (
					<div className="text-center">
						<h2 className="login-form-heading">Error</h2>
						<p className="login-form-heading">Invalid reset code.</p>
					</div>
				) : (
					<Form
						onSubmit={this.submit}
						decorators={[focusOnErrors]}
						subscription={{ submitting: true, submitError: true }}
						render={({ handleSubmit, submitError, submitting }) => (
							<form onSubmit={handleSubmit} className="login-form">
								<h2 className="login-form-heading">
									Please enter your username and your new password.
								</h2>
								{submitError ? (
									<div data-testid="login-error">
										<Alert color="danger">{submitError}</Alert>
									</div>
								) : null}

								<Field
									name="username"
									placeholder="username"
									type="text"
									autoFocus
									indicateDirty={false}
									className="login-form__row login-form__text-input"
									component={Input}
									data-testid="login-username"
								/>

								<Field
									name="password"
									placeholder="password"
									type="password"
									indicateDirty={false}
									className="login-form__row login-form__text-input"
									component={Input}
									data-testid="login-password"
								/>

								<Field
									name="confirmPassword"
									placeholder="confirm password"
									type="password"
									indicateDirty={false}
									className="login-form__row login-form__text-input"
									component={Input}
									data-testid="login-confirm-password"
								/>

								<div className="login-form__actions form-group">
									<Button
										type="submit"
										disabled={submitting}
										color="primary"
										className="btn login-form__action login-form__submit-btn"
										data-testid="login-submit"
									>
										Set Password
									</Button>
								</div>
								<div className="login-form__actions form-group">{submitting ? <Spinner /> : null}</div>
							</form>
						)}
					/>
				)}
			</div>
		);
	}
}

export default ResetPassword;
